import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { t } from 'src/lib/language';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { useEffect } from 'react';
import { setSelections } from 'src/redux/actions/selectionActions';
import { ENTITIES } from 'src/models/QuerybuilderModel';

interface Props {
  paymentId?: string | number;
}

const DownloadPaymentButton = (props: ButtonProps & Props) => {
  const dispatch = useAppDispatch();
  const { disabled } = props;

  const lang = useSelector((state: Store) => state.language.language);
  const { paymentId } = props;

  useEffect(() => {
    if (paymentId) {
      dispatch(setSelections({
        entity: ENTITIES.payments,
        selections: [paymentId],
      }));
    }
  }, [paymentId]);

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.paymentDownload }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.download_payments')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOpen}
            disabled={disabled || !paymentId}>
            <GetAppIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default DownloadPaymentButton;
